import { render, staticRenderFns } from "./security.html?vue&type=template&id=b5155d14&scoped=true&"
import script from "./security.js?vue&type=script&lang=js&"
export * from "./security.js?vue&type=script&lang=js&"
import style0 from "./security.scss?vue&type=style&index=0&id=b5155d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5155d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5155d14')) {
      api.createRecord('b5155d14', component.options)
    } else {
      api.reload('b5155d14', component.options)
    }
    module.hot.accept("./security.html?vue&type=template&id=b5155d14&scoped=true&", function () {
      api.rerender('b5155d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/moneycan-loan/security/security.vue"
export default component.exports